export const REDIRECT_PATH = 'redirect_path';
